import '../Assets/Styles/register.css';
import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive'

import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';

import Box from '@mui/material/Box';

// Load Actions
import * as AppActions from '../Store/Actions/App';

import {
    disableBodyScroll,
    enableBodyScroll
} from './Utils';


// UpdateService dialog component
const DataView = (props) => {

// set vars from props
const { 
    dataModal,
    setDataModal,
    scrollBlock
} = props;		

const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

const [loading, setLoading] = React.useState(true);



const footerContent = (
    <div className="modalFooterButtonsEnd">

        <div>
            <Button label="Fechar" icon="pi pi-times" className="p-button-text" onClick={() => close()} />
        </div>
        
    </div>
);		
    

// Execute when dialog opens
React.useEffect(() => {

    // Only runs when  dialog opens
    if (dataModal) {

        disableBodyScroll();
        
    } // end if
    
    // Runs when UNMOUNT component
    return () => {
        enableBodyScroll();
    };


},[dataModal]);

const close = ()=> {
    setDataModal(false);
    enableBodyScroll();
}
    
    return (
    <>
            <Dialog header="Uso de dados" visible={dataModal} style={{ width: isMobile ? '100vw' : '55vw', height: isMobile ? '100vh' : 'auto' }} breakpoints={{ '1400px': '75vw','960px': '80vw', '641px': '100vw' }} onHide={() => close()} footer={footerContent} >

                <Box
                  sx={{
                    width: "100%",
                  }}
                  className="terms"
                >
                    
                    <Divider />
                    
                        <h2>1. Termo de Consentimento para Tratamento de Dados Pessoais</h2>
                        <p>
                            Este documento visa registrar a manifestação livre, informada e inequívoca pela qual o Agente de Viagens que realizou o login no site e a reserva, informou ao passageiro envolvido, doravante denominado Titular, sobre este Termo e que ambos concordam com o tratamento de seus dados pessoais para finalidade específica, em conformidade com a Lei nº 13.709 – Lei Geral de Proteção de Dados Pessoais (LGPD).
                        </p>
                        <p>
                            Ao clicar que aceita o presente termo, o Titular consente e concorda que a empresa SM Travel Agência de Viagens e Turismo LTDA, CNPJ nº 07.760.188/0001-15, com sede na Praia de Botafogo, 440 Sl 702, telefone 4020-9749, e-mail administrativo@smilatam.net, doravante denominada Controlador, tome decisões referentes ao tratamento de seus dados pessoais, bem como realize o tratamento dos seus dados pessoais, envolvendo operações como coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou extração.
                        </p>

                        <h2>2. Dados Pessoais</h2>
                        <p>
                            O Controlador fica autorizado a tomar decisões referentes ao tratamento e a realizar o tratamento dos seguintes dados pessoais do(s) passageiro(s) e do agente de viagens:
                        </p>
                        <ul>
                            <li>Nome completo</li>
                            <li>Data de nascimento ou idade</li>
                            <li>Número e imagem do CPF</li>
                            <li>Número e imagem de documento pessoal de identificação (ex.: CNH, RG, passaporte, certidão de nascimento)</li>
                            <li>Números de telefone, WhatsApp e endereços de e-mail</li>
                            <li>Informações de cartão de crédito: bandeira, número, validade, código de segurança e instituição bancária</li>
                            <li>Informações pessoais exigidas de acordo com o serviço reservado</li>
                            <li>Locais de hospedagem</li>
                            <li>Datas, destinos e serviços turísticos reservados</li>
                            <li>Nome de usuário e senha específicos para uso dos serviços do Controlador</li>
                            <li>Comunicação verbal e escrita mantida entre o Agente de Viagens e o Controlador</li>
                        </ul>

                        <h2>3. Finalidades do Tratamento dos Dados</h2>
                        <p>
                            O tratamento dos dados pessoais listados neste termo tem as seguintes finalidades:
                        </p>
                        <ul>
                            <li>Permitir que o Controlador identifique e entre em contato com o Agente de Viagens e o Titular para fins de relacionamento operacional e/ou comercial</li>
                            <li>Permitir que o Controlador elabore contratos comerciais e emita cobranças contra o Titular</li>
                            <li>Permitir que o Controlador envie ou forneça ao Titular seus produtos e serviços, de forma remunerada</li>
                            <li>Permitir que o Controlador estruture, teste, promova e faça propaganda de produtos e serviços, personalizados ou não, à operação do Agente de Viagens</li>
                        </ul>

                        <h2>4. Compartilhamento de Dados</h2>
                        <p>
                            O Controlador fica autorizado a compartilhar os dados pessoais do Titular com outros agentes de tratamento de dados (fornecedores locais dos serviços reservados), caso seja necessário para as finalidades listadas neste termo, observados os princípios e garantias estabelecidas pela Lei nº 13.709.
                        </p>

                        <h2>5. Segurança dos Dados</h2>
                        <p>
                            O Controlador responsabiliza-se pela manutenção de medidas de segurança, técnicas e administrativas aptas a proteger os dados pessoais de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou qualquer forma de tratamento inadequado ou ilícito.
                        </p>
                        <p>
                            Em conformidade com o art. 48 da Lei nº 13.709, o Controlador comunicará ao Titular e à Autoridade Nacional de Proteção de Dados (ANPD) a ocorrência de incidente de segurança que possa acarretar risco ou dano relevante ao Titular.
                        </p>

                        <h2>6. Término do Tratamento dos Dados</h2>
                        <p>
                            O Controlador poderá manter e tratar os dados pessoais do Titular durante todo o período em que os mesmos forem pertinentes ao alcance das finalidades listadas neste termo. Dados pessoais anonimizados, sem possibilidade de associação ao indivíduo, poderão ser mantidos por período indefinido, de acordo com as legislações específicas brasileiras.
                        </p>
                        <p>
                            O Titular poderá solicitar, via e-mail ou correspondência ao Controlador, a qualquer momento, que sejam eliminados os dados pessoais não anonimizados do Titular. O Titular fica ciente de que poderá ser inviável ao Controlador continuar o fornecimento de produtos ou serviços ao Titular a partir da eliminação dos dados pessoais.
                        </p>

                        <h2>7. Direitos do Titular</h2>
                        <p>
                            O Titular tem direito a obter do Controlador, em relação aos dados por ele tratados, a qualquer momento e mediante requisição:
                        </p>
                        <ul>
                            <li>Confirmação da existência de tratamento</li>
                            <li>Acesso aos dados</li>
                            <li>Correção de dados incompletos, inexatos ou desatualizados</li>
                            <li>Anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com a Lei nº 13.709</li>
                            <li>Portabilidade dos dados a outro fornecedor de serviço ou produto, mediante requisição expressa</li>
                            <li>Eliminação dos dados pessoais tratados com consentimento do Titular, exceto nas hipóteses previstas no art. 16 da Lei nº 13.709</li>
                            <li>Informação das entidades públicas e privadas com as quais o Controlador realizou uso compartilhado de dados</li>
                            <li>Informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa</li>
                            <li>Revogação do consentimento, nos termos do §5º do art. 8º da Lei nº 13.709</li>
                        </ul>

                        <h2>8. Direito de Revogação do Consentimento</h2>
                        <p>
                            Este consentimento poderá ser revogado pelo Titular, a qualquer momento, mediante solicitação via e-mail ou correspondência ao Controlador.
                        </p>
                        
                        
            </Box>
            </Dialog>	
    </>	
    );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(DataView);	
